import React from 'react';
import { Accordion, AccordionItem, AccordionButton, AccordionPanel, Box, List, ListItem, Icon } from '@chakra-ui/react';
import { ChevronRightIcon, ChevronDownIcon } from '@chakra-ui/icons';

const CustomTreeNode = ({ node, level = 0, onNodeClick }) => {
  const hasChildren = node.children && node.children.length > 0;

  return (
    <AccordionItem border="none">
      {({ isExpanded }) => (
        <>
          <AccordionButton
            px={2}
            py={1}
            pl={level * 4} // Indent based on level
            _hover={{ bg: 'gray.100' }}
            onClick={(e) => {
              // If no children, handle click for the node itself
              if (!hasChildren && onNodeClick) {
                e.stopPropagation();
                onNodeClick(node);
              }
            }}
          >
            <Box flex="1" textAlign="left">
              <Icon as={hasChildren ? (isExpanded ? ChevronDownIcon : ChevronRightIcon) : null} mr={2} />
              {node.label}
            </Box>
          </AccordionButton>
          {hasChildren && (
            <AccordionPanel pb={0} pl={level * 4 + 4}>
              <List spacing={1}>
                {node.children.map((child) => (
                  <ListItem key={child.id}>
                    <CustomTreeNode 
                      node={child} 
                      level={level + 1} 
                      onNodeClick={onNodeClick}
                    />
                  </ListItem>
                ))}
              </List>
            </AccordionPanel>
          )}
        </>
      )}
    </AccordionItem>
  );
};

const CustomTreeView = ({ data, onNodeClick }) => (
  <Accordion allowMultiple defaultIndex={[]}>
    <CustomTreeNode node={data} onNodeClick={onNodeClick} />
  </Accordion>
);

export default CustomTreeView;
